import "../../assets/css/grid.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import logo from '../../assets/images/logo.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import * as planApis from 'apis/plans';
import * as userApis from 'apis/users';
import * as subscriptionApis from 'apis/subscriptions';
import * as signupPromoApis from 'apis/signupPromos';
import { useRazorpay } from "react-razorpay";


function SignupPage() {
  const location = useLocation();
  const data = location.state;
  const navigate = useNavigate();
  const selectedPlanId = data?.id;

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const role = localStorage.getItem('role');
      navigate(role === 'partner' ? '/partner/verify' : '/dashboard/my-subscription', { replace: true });
      return;
    }
    if (!selectedPlanId) {
      navigate('/Plans#plans', { replace: true });
    }
  }, [selectedPlanId, navigate]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    agreeToTerms: false, 
    plan:data?.id|| '',

  });

  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [showSignUp, setShowSignUp] = useState(true);
  const [verificationCode, setVerificationCode] = useState("");
  const [subscription, setSubscription] = useState("");
  const [showPayment, setShowPayment ] = useState(false);
  const [paymentStatus, setPaymentStatus ] = useState("");
  const [promoCodeInput, setPromoCodeInput] = useState("");
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [promoError, setPromoError] = useState("");
  const [promoApplying, setPromoApplying] = useState(false);
  

  const [plans, setPlans] = useState([]);
  useEffect(() => {
    if (!selectedPlanId) {
      return;
    }
    const fetchData = async () => {
        try {
            const response = await planApis.fetchPlans();
            setPlans(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    fetchData();
}, [selectedPlanId]);


  useEffect(() => {
    if(formSubmitted){
      validateForm();
    }
  }, [formData]);
  // Validate form inputs
  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First Name is required";
      valid = false;
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last Name is required";
      valid = false;
    }
    if (!formData.phone.trim() || !/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Valid phone number is required";
      valid = false;
    }
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Valid email is required";
      valid = false;
    }
    if (!formData.password.trim() || formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
      valid = false;
    }
    if (!formData.agreeToTerms) {
      newErrors.agreeToTerms = "You must agree to the terms";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  // Handle form change
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    if (name === "plan") {
      setAppliedPromo(null);
      setPromoError("");
    }
  };

  const apiErrorMessage = (error, fallback) =>
    error?.response?.data?.message || error?.response?.data?.error || fallback;

  const selectedPlan = plans.find((plan) => plan.id == formData?.plan);
  // New signups always qualify; the backend makes the final call.
  const isFreePlan = Boolean(selectedPlan?.isFreePeriodEnabled);
  const payAmount = appliedPromo
    ? appliedPromo.estimatedFirstAmount
    : selectedPlan?.price;
  const hasUnappliedPromo =
    !isFreePlan &&
    !!promoCodeInput.trim() &&
    (!appliedPromo ||
      appliedPromo.code !== promoCodeInput.trim().toUpperCase());
  const payButtonLabel = isFreePlan
    ? "Sign Up & Start for ₹0"
    : appliedPromo
    ? `Sign Up & Pay ₹${payAmount}`
    : `Sign Up & Pay ₹${selectedPlan?.price ?? ""}`;
  const verifyPayLabel = isFreePlan
    ? "Verify & Start for ₹0"
    : appliedPromo
    ? `Verify & Pay ₹${payAmount}`
    : `Verify & Pay ₹${selectedPlan?.price ?? ""}`;
  const retryPayLabel = subscription?.freePeriodEndsAt
    ? "Start for ₹0"
    : `Pay ₹${payAmount ?? selectedPlan?.price ?? ""}`;

  const handleClearPromo = () => {
    setPromoCodeInput("");
    setAppliedPromo(null);
    setPromoError("");
  };

  const handleApplyPromo = async () => {
    setPromoError("");
    if (!promoCodeInput.trim()) {
      setPromoError("Enter a promo code");
      return;
    }
    if (!formData.plan) {
      setPromoError("Select a plan first");
      return;
    }
    setPromoApplying(true);
    try {
      const response = await signupPromoApis.validate({
        code: promoCodeInput.trim(),
        planId: Number(formData.plan),
      });
      setAppliedPromo(response.data);
    } catch (error) {
      setAppliedPromo(null);
      setPromoError(
        apiErrorMessage(error, "Invalid promo code") +
          ". Remove the code to continue without a discount.",
      );
    } finally {
      setPromoApplying(false);
    }
  };

  const handleVerification = async() =>{
      if (hasUnappliedPromo) {
        setSubmitError("Please apply the promo code, or remove it to continue without a discount.");
        return;
      }
      try{
        const response = await userApis.verify({...formData, verificationCode});
      const { subscriptionToken} = response.data;
      const subscriptionResponse = await subscriptionApis.create({
        planId:formData.plan,
        subscriptionToken,
        ...(appliedPromo?.code && !isFreePlan ? { promoCode: appliedPromo.code } : {}),
      })
      const subscription = subscriptionResponse.data;
      const{ email, phone } = formData;
      setSubscription({...subscription, email, phone, subscriptionToken});
      setPaymentStatus("initializing");
      setShowPayment(true);
      handlePayment({...subscription, email, phone, subscriptionToken });  
      }
      catch(error){
        setSubmitError(apiErrorMessage(error, "Verification failed. Please try again."));
      }
      
      //load UI 

  }

  // Handle form submission
  const handleSignup = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setSubmitError(""); // Reset error message

    if (validateForm()) {
      if (hasUnappliedPromo) {
        setPromoError("Please apply the promo code, or remove it to continue without a discount.");
        return;
      }
      try {
        
        const response = await userApis.signUp(formData);
        if(response.data){
          setShowSignUp(false);
        }
        // Call your signup API function here, passing formData
        //await signupAPI(formData);
        // If success, you can redirect or show success message

        
      } catch (error) {
        setSubmitError(apiErrorMessage(error, "Signup failed. Please try again."));
      }
    }
    else{
      console.log('invalid form');
    }
  };

  const { error, isLoading, Razorpay } = useRazorpay();

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const initializePayment = () => {
    handlePayment({...subscription})
  }

  const handlePayment = ({razorpayKey, subscriptionId, email, phone, subscriptionToken}) => {
    const options = {
      key: razorpayKey,

      name: "The Taurian",
      description: "Subscription Payment",
      subscription_id: subscriptionId,
      image: "/your_logo.jpg",
      handler: async (response) => {
        console.log(response);
        const {razorpay_payment_id: paymentId, razorpay_subscription_id: subscriptionId,razorpay_signature:signature } = response;
        try{
          let verificationResponse;
          let shouldWait = true;
      
          // Retry loop until verification completes
          while (shouldWait) {
            verificationResponse = await subscriptionApis.verify({
              paymentId,
              subscriptionId,
              signature,
              subscriptionToken,
            });
      
            if (!verificationResponse.data.wait) {
              shouldWait = false; // Break the loop if verification is complete
            } else {
              setPaymentStatus("waiting_for_confirmation"); 
              await delay(2000); // Wait for 2 seconds (or your desired interval) before retrying
            }
          }
      
          // Handle successful verification or any additional logic here
          setPaymentStatus('verified');
          localStorage.setItem('token', verificationResponse.data.session);
          navigate('/dashboard');


        }
        catch(error){
          alert(error);
        }
				
      },
      prefill: {
        email,
        contact: phone,
      },
      theme: {
        color: "#F37254",
      },
      "modal": {
        "ondismiss": function () {
          setPaymentStatus("to_be_initialized");
          }
        }

    };
 
    const razorpayInstance = new Razorpay(options);
    razorpayInstance.open();
    razorpayInstance.on('payment.failed', function (response){
      alert("Your Payment Failed, Try again");
});
  };

  if (localStorage.getItem('token') || !selectedPlanId) {
    return null;
  }

  return (
    showSignUp?
    <div className="App">
      <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
        <div className="login pt-40">
          <div className="logo">
            <img src={logo} alt="Logo" />
          </div>
          <div className="login-title">
            <h1>Get started!</h1>
            <h6>Please enter your details to continue.</h6>
          </div>

          <form className="login-form" onSubmit={handleSignup}>
          <div className="login-input">
            <label>Plan </label>

            <select
              name="plan"
              value={formData.plan || plans[1]?.id}
              onChange={handleInputChange}
            >
             
              {plans.map(plan=>{
                return (<option value={plan.id}>{plan.name} ₹{Math.trunc(plan.price)} {plan.billingCycle}</option>)

              } )}
            </select>
            {errors.plan && (
              <div className="errors">
                <h1>{errors.plan}</h1>
              </div>
            )}
          </div>

          {isFreePlan ? (
            selectedPlan?.freePeriodText && (
              <div className="login-input">
                <div className="promo-applied">
                  ₹0 {selectedPlan.freePeriodText}, then ₹{Math.trunc(selectedPlan.price)}/{selectedPlan.billingCycle}
                </div>
              </div>
            )
          ) : (
          <div className="login-input promo-code-row">
            <label>Promo code (optional)</label>
            <div className="promo-code-fields">
              <input
                type="text"
                name="promoCode"
                placeholder="Enter code"
                value={promoCodeInput}
                onChange={(e) => {
                  setPromoCodeInput(e.target.value.toUpperCase());
                  setPromoError("");
                  setAppliedPromo(null);
                }}
              />
              <button type="button" onClick={handleApplyPromo} disabled={promoApplying}>
                {promoApplying ? "Applying..." : appliedPromo ? "Applied" : "Apply"}
              </button>
              {promoCodeInput.trim() ? (
                <button type="button" className="promo-clear" onClick={handleClearPromo}>
                  Remove
                </button>
              ) : null}
            </div>
            {promoError && (
              <div className="errors">
                <h1>{promoError}</h1>
              </div>
            )}
            {appliedPromo && (
              <div className="promo-applied">
                {appliedPromo.message || `Code ${appliedPromo.code} applied.`}
              </div>
            )}
          </div>
          )}

            <div className="login-input">
              <label>First Name</label>
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleInputChange}
              />
              {errors.firstName && 
              <div className="errors">
                <h1>{errors.firstName}</h1>
              </div>
              }
            </div>

            <div className="login-input">
              <label>Last Name</label>
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleInputChange}
              />
              {errors.lastName && 
              <div className="errors">
                <h1>{errors.lastName}</h1>
              </div>
              }
            </div>

            <div className="login-input">
              <label>Phone number</label>
              <input
                type="text"
                name="phone"
                placeholder="Phone number"
                value={formData.phone}
                onChange={handleInputChange}
              />
             {errors.phone && 
              <div className="errors">
                <h1>{errors.phone}</h1>
              </div>
              }
            </div>

            <div className="login-input">
              <label>Email address</label>
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleInputChange}
              />
             {errors.email && 
              <div className="errors">
                <h1>{errors.email}</h1>
              </div>
              }
            </div>

            <div className="login-input">
              <label>Password</label>
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
              />
             {errors.password && 
              <div className="errors">
                <h1>{errors.password}</h1>
              </div>
              }
            </div>

            <div className="login-input">
              <input
                type="checkbox"
                id="iagree"
                name="agreeToTerms"
                checked={formData.agreeToTerms}
                onChange={handleInputChange}
              />
              <label className="inlinedisplay" htmlFor="iagree">
                I agree to <a href="#">Terms & Conditions</a>
              </label>
              {errors.agreeToTerms && 
                <div className="errors">
                  <h1>{errors.agreeToTerms}</h1>
                </div>
                }
            </div>

            {submitError && <div className="errors">
                  <h1>{submitError}</h1>
                </div>}
            <div className="login-input">
              <button type="submit">{payButtonLabel}</button>
            </div>
          </form>

          <div className="login-footer">
            <p>
              Already have an account?{" "}
              <Link to="/Login">Login</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
    :!!!showPayment?
    <div className="App">
      <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
        <div className="login pt-40">
          <div className="logo">
          <img  src={logo} alt="" />
          </div>
          <div className="login-title">
          <h1>Verify OTP</h1>
          <h6>We sent a code to <b>{formData.email}</b></h6>
          {appliedPromo && !isFreePlan && (
            <h6>{appliedPromo.message}</h6>
          )}
          </div>
        

        <div className="login-form">
          <div className="login-input">
            <label for="verificationCode"> OTP</label>
            <input
                type="text"
                name="verificationCode"
                placeholder="Enter 6-digit OTP"
                value={verificationCode}
                onChange={(e)=>setVerificationCode(e.target.value)}
                maxLength={6}
                inputMode="numeric"
                pattern="[0-9]*"
              />
        </div>

         
          <div className="errors">
            <h1>{submitError}</h1>
          </div> 

         
          <div className="login-input">
            <button  onClick={()=>handleVerification()}>{verifyPayLabel}</button>
          </div>
          </div>
          

        </div>
      </div> 

      
    </div>
    :
    <div className="App">
    <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
      <div className="login pt-40">
        <div className="logo">
        <img  src={logo} alt="" />
        </div>
        <div className="login-title">
        <h1>{paymentStatus === 'to_be_initialized'?"Complete Your Payment": "Processing Your Payment..."}</h1>
        </div>
        <div className="payment-status-container">
      <div className={`payment-status ${paymentStatus}`}>
        {paymentStatus === 'initializing' && <p>Initializing Payment...</p>}
        {paymentStatus === 'verifying' && <p>Verifying Payment...</p>}
        {paymentStatus === 'waiting_for_confirmation' && <p>Waiting for Confirmation...</p>}
        {paymentStatus === 'to_be_initialized'&&  <div className="login-input"><button onClick={initializePayment}>{retryPayLabel}</button></div>}
        
      </div>
    </div>  

        

      </div>
    </div>

    
  </div>

  );
}

export default SignupPage;